// Sidebar entries owned by the Invoice module. The shell places them: see
// src/app/nav.tsx and src/modules/README.md.
import { SidebarType } from '@/types/shared'
import { resources, scopes } from '@/utils/permission'
import { invoicePaths } from './paths'

export const invoiceNav = {
    list: {
        title: 'invoice:sidebar_title',
        path: invoicePaths.invoices,
        rsname: resources.invoices,
        require_scopes: [scopes.index],
        visible_permission_denied: false,
    },
} satisfies Record<string, SidebarType>
